import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

export interface IModalProps {
  open: boolean;
  closeModal: () => void;
  children?: React.ReactNode;
}

export default function Modal({ open = false, closeModal, children }: IModalProps) {
  return (
    <Transition
      // @ts-ignore - ts-expect-error - TypeScript compatibility issue with React 18 and HeadlessUI
      appear
      show={open}
      // @ts-ignore - ts-expect-error - TypeScript compatibility issue with React 18 and HeadlessUI
      as={Fragment}
    >
      {/* @ts-ignore - TypeScript compatibility issue with React 18 and HeadlessUI */}
      <Dialog as="div" className="relative z-20" onClose={closeModal} unmount>
        <Transition.Child
          // @ts-ignore - ts-expect-error - TypeScript compatibility issue with React 18 and HeadlessUI
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          {/* @ts-ignore - TypeScript compatibility issue with React 18 types */}
          <span className="fixed inset-0 bg-primary bg-opacity-50 backdrop-blur-lg" />
        </Transition.Child>
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              // @ts-ignore - ts-expect-error - TypeScript compatibility issue with React 18 and HeadlessUI
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              {/* @ts-ignore - TypeScript compatibility issue with React 18 types */}
              <Dialog.Panel className="transform transition-all mx-auto">
                {/* @ts-ignore - TypeScript compatibility issue with React 18 types */}
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
